module.exports = __webpack_public_path__ + "static/media/about_you_wide.ea3f92fa.svg";